
















































import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import { TemplateContentEnum } from "@/model/data/enums/TemplateContentEnum";
import Vue from "vue";
import { mapGetters } from "vuex";
import SecurityConfigurationCard from "./SecurityConfigurationCard.vue";
export default Vue.extend({
    components: { SecurityConfigurationCard },
    props: {
        showDialog: { type: Boolean, required: true },
        loading: Boolean,
        installationName: String,
        fromStocksConfig: { type: Boolean, default: false },
    },
    data() {
        return {
            templateName: "",
            templateContent: TemplateContentEnum.None,
            delaysCheckbox: false,
            alarmsCheckbox: false,
            timeBandsCheckbox: false,
        };
    },
    watch: {
        installationName() {
            this.templateName = "";
            this.templateContent = TemplateContentEnum.None;
            this.delaysCheckbox = false;
            this.alarmsCheckbox = false;
            this.timeBandsCheckbox = false;
        },
    },
    computed: {
        ...mapGetters(["authUserHasPrivilege"]),

        delaysEnabled() {
            return this.authUserHasPrivilege(ClientPrivileges.ReadDelays);
        },

        alarmsEnabled() {
            return this.authUserHasPrivilege(ClientPrivileges.ReadAlarms);
        },

        timebandsEnabled() {
            return this.authUserHasPrivilege(ClientPrivileges.ReadBands);
        },
        canExport() {
            return !(
                this.templateName == null ||
                this.templateName == undefined ||
                this.templateName.replace(/\s/g, "").length == 0 ||
                (!this.fromStocksConfig && !this.delaysCheckbox && !this.alarmsCheckbox && !this.timeBandsCheckbox)
            );
        },
        showExportTemplateDialog: {
            get() {
                return this.showDialog;
            },
            set(newValue: boolean) {
                this.$emit("update:showDialog");
            },
        },
    },
    methods: {
        exportConfiguration() {
            this.templateContent = TemplateContentEnum.None;
            if (this.fromStocksConfig) this.templateContent |= TemplateContentEnum.Rollconfig;
            else {
                if (this.delaysCheckbox) this.templateContent |= TemplateContentEnum.Delays;
                if (this.alarmsCheckbox) this.templateContent |= TemplateContentEnum.Alarms;
                if (this.timeBandsCheckbox) this.templateContent |= TemplateContentEnum.TimeBands;
            }
            this.$emit("export-configuration", this.templateName.trim(), this.templateContent);
        },
    },
});
